// Theme: dusty-laser
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'dusty-laser',
  name: 'DUSTY LASER',
  tagline: 'DUSTY LASER',
  description: 'Violeta difuso como laser atravessando neblina.',
  category: 'neon-cyber',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#180F20', '#251535', '#D8B4FE', '#F3E8FF'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 14px 36px rgba(0, 0, 0, 0.24)',
      '--shadow-card-active': '0 14px 36px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-mono theme-dusty-laser'
  },
  colorVars: {
    '--accent': '#D8B4FE',
    '--accent-foreground': '#180F20',
    '--background': '#180F20',
    '--border': '#6A3A8A',
    '--card': '#251535',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 68%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F3E8FF',
    '--card-glow': 'color-mix(in srgb, var(--primary) 14%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#180F20',
    '--foreground': '#F3E8FF',
    '--hold-fill': '#D8B4FE',
    '--input': '#6A3A8A',
    '--modal-bg': '#180F20',
    '--modal-border': '#6A3A8A',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px rgba(0, 0, 0, 0.24)',
    '--muted': '#6A3A8A',
    '--muted-foreground': '#F3E8FF',
    '--nav-active': '#D8B4FE',
    '--nav-bg': '#251535',
    '--popover': '#251535',
    '--popover-foreground': '#F3E8FF',
    '--primary': '#D8B4FE',
    '--primary-foreground': '#180F20',
    '--ring': '#D8B4FE',
    '--secondary': '#6A3A8A',
    '--secondary-foreground': '#F3E8FF',
    '--streak': '#D8B4FE',
    '--success': '#22c55e',
    '--success-foreground': '#180F20',
    '--xp': '#D8B4FE',
    '--xp-bg': '#251535'
  },
  resolvedVars: {
    '--accent': '#D8B4FE',
    '--accent-foreground': '#180F20',
    '--accent-foreground-hsl': '272 36% 9%',
    '--accent-foreground-oklch': 'from #180F20 l c h',
    '--accent-hsl': '269 97% 85%',
    '--accent-oklch': 'from #D8B4FE l c h',
    '--background': '#180F20',
    '--background-hsl': '272 36% 9%',
    '--background-oklch': 'from #180F20 l c h',
    '--border': '#6A3A8A',
    '--border-hsl': '276 41% 38%',
    '--border-oklch': 'from #6A3A8A l c h',
    '--border-w': '1px',
    '--card': '#251535',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 68%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F3E8FF',
    '--card-foreground-hsl': '269 100% 95%',
    '--card-foreground-oklch': 'from #F3E8FF l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 14%, transparent)',
    '--card-hsl': '270 43% 15%',
    '--card-oklch': 'from #251535 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#180F20',
    '--destructive-foreground-hsl': '272 36% 9%',
    '--destructive-foreground-oklch': 'from #180F20 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F3E8FF',
    '--foreground-hsl': '269 100% 95%',
    '--foreground-oklch': 'from #F3E8FF l c h',
    '--hold-fill': '#D8B4FE',
    '--hold-fill-hsl': '269 97% 85%',
    '--hold-fill-oklch': 'from #D8B4FE l c h',
    '--input': '#6A3A8A',
    '--input-hsl': '276 41% 38%',
    '--input-oklch': 'from #6A3A8A l c h',
    '--modal-bg': '#180F20',
    '--modal-bg-hsl': '272 36% 9%',
    '--modal-bg-oklch': 'from #180F20 l c h',
    '--modal-border': '#6A3A8A',
    '--modal-border-hsl': '276 41% 38%',
    '--modal-border-oklch': 'from #6A3A8A l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 14px 36px rgba(0, 0, 0, 0.24)',
    '--muted': '#6A3A8A',
    '--muted-foreground': '#F3E8FF',
    '--muted-foreground-hsl': '269 100% 95%',
    '--muted-foreground-oklch': 'from #F3E8FF l c h',
    '--muted-hsl': '276 41% 38%',
    '--muted-oklch': 'from #6A3A8A l c h',
    '--nav-active': '#D8B4FE',
    '--nav-active-hsl': '269 97% 85%',
    '--nav-active-oklch': 'from #D8B4FE l c h',
    '--nav-bg': '#251535',
    '--nav-bg-hsl': '270 43% 15%',
    '--nav-bg-oklch': 'from #251535 l c h',
    '--popover': '#251535',
    '--popover-foreground': '#F3E8FF',
    '--popover-foreground-hsl': '269 100% 95%',
    '--popover-foreground-oklch': 'from #F3E8FF l c h',
    '--popover-hsl': '270 43% 15%',
    '--popover-oklch': 'from #251535 l c h',
    '--primary': '#D8B4FE',
    '--primary-foreground': '#180F20',
    '--primary-foreground-hsl': '272 36% 9%',
    '--primary-foreground-oklch': 'from #180F20 l c h',
    '--primary-hsl': '269 97% 85%',
    '--primary-oklch': 'from #D8B4FE l c h',
    '--radius': '10px',
    '--ring': '#D8B4FE',
    '--ring-hsl': '269 97% 85%',
    '--ring-oklch': 'from #D8B4FE l c h',
    '--secondary': '#6A3A8A',
    '--secondary-foreground': '#F3E8FF',
    '--secondary-foreground-hsl': '269 100% 95%',
    '--secondary-foreground-oklch': 'from #F3E8FF l c h',
    '--secondary-hsl': '276 41% 38%',
    '--secondary-oklch': 'from #6A3A8A l c h',
    '--shadow-card': '0 14px 36px rgba(0, 0, 0, 0.24)',
    '--shadow-card-active': '0 14px 36px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#D8B4FE',
    '--streak-hsl': '269 97% 85%',
    '--streak-oklch': 'from #D8B4FE l c h',
    '--success': '#22c55e',
    '--success-foreground': '#180F20',
    '--success-foreground-hsl': '272 36% 9%',
    '--success-foreground-oklch': 'from #180F20 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(269 97% 85% / 0.15)',
    '--xp': '#D8B4FE',
    '--xp-bg': '#251535',
    '--xp-bg-hsl': '270 43% 15%',
    '--xp-bg-oklch': 'from #251535 l c h',
    '--xp-hsl': '269 97% 85%',
    '--xp-oklch': 'from #D8B4FE l c h'
  }
}
